import { useContext } from 'react';
import { ThemesContext } from './ThemesContext';
export var useThemesContext = function (params) {
    var _a = params || {}, lightTheme = _a.lightTheme, darkTheme = _a.darkTheme, defaultTheme = _a.defaultTheme;
    var context = useContext(ThemesContext);
    return {
        lightTheme: lightTheme || context.lightTheme,
        darkTheme: darkTheme || context.darkTheme,
        defaultTheme: defaultTheme !== null && defaultTheme !== void 0 ? defaultTheme : context.defaultTheme,
    };
};
//# sourceMappingURL=useThemesContext.js.map